<template>
    <v-container
        class="white pt-0"
        style="overflow-x: hidden"
    >

                <!--------------------------------->
                <!--      Set Content Width      -->
                <!--------------------------------->
        <v-row
            justify="center"
        >
            <v-col
                xs="12"
                sm="8"
                md="7"
                lg="6"
                xl="5"
                class="mx-2"
            >

                <!--------------------------------->
                <!--     Shopping List Week      -->
                <!--------------------------------->
                <v-row
                    justify="center"
                    class="my-0 py-0"
                >
                    {{weekStart | moment("MM/DD/YYYY")}}
                    - 
                    {{weekEnd | moment("MM/DD/YYYY")}}
                </v-row>

                <!--------------------------------->
                <!--       List Header Row       -->
                <!--------------------------------->
                <v-row
                    align="center"
                >
                    <v-col
                        class="text-left ml-3 my-0 pa-0"
                    >
                        <v-row
                            align="center"
                            class = "ma-0 pa-0"
                        >
                            <v-switch
                                v-model="showAllShoppingList"
                                color="blue"
                            />
                            <div
                                class="ml-2"
                            >
                                Show All
                            </div>
                        </v-row>
                    </v-col>

                    <v-col
                        class="text-right mr-3 pa-0"
                    >
                        <v-btn
                            icon
                            x-large
                        >
                            <v-icon
                                x-large
                                color="grey darken-4"
                            >
                                local_shipping
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
        
                <!--------------------------------->
                <!--        Shopping List        -->
                <!--------------------------------->
                <v-row
                    v-for="(category,c) in shoppingList"
                    :key="c"
                    align="start"
                    justify="center"
                    class="black--text ma-0 pa-0"
                >
                    <v-col
                        v-if="showAllShoppingList || (category.items.filter(function(e){ return e.purchased == false;})).length > 0"
                        class="ma-0 px-5"
                        xs="12"
                        sm="10"
                        md="10"
                        lg="8"
                        xl="6"
                    >
                        <h3>
                            {{category.category}}:
                        </h3>
                        <table>
                            <tbody>
                                <tr
                                    v-for="(item,i) in category.items"
                                    :key="i"
                                    class="body-2"
                                >
                                    <td
                                        v-if="showAllShoppingList || !item.purchased"
                                    >
                                        <v-btn 
                                            icon
                                            light
                                            color="grey darken-4"
                                            @click.prevent="checkBox([c,i])"
                                        >
                                            <v-icon
                                                v-if="!item.purchased"
                                                filled
                                            >
                                                check_box_outline_blank
                                            </v-icon>
                                            <v-icon
                                                v-else
                                            >
                                                mdi-check-box-outline
                                            </v-icon>
                                        </v-btn>
                                    </td>
                                    <td
                                        v-if="showAllShoppingList || !item.purchased"
                                        style="vertical-align: middle"
                                    >
                                        {{item.quantity}} - {{item.units}} {{item.name}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="text-right">

                <!--------------------------------->
                <!-- Initialize Add Item Dialog  -->
                <!--------------------------------->
                        <v-dialog
                            v-model="addItem"
                            persistent
                            width="500"
                            >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    fab
                                    small
                                    color="blue"
                                    v-on="on"
                                >
                                    <v-icon medium color="white">
                                        add
                                    </v-icon>
                                </v-btn>
                            </template>

                <!--------------------------------->
                <!--   Add Item Dialog Content   -->
                <!--------------------------------->
                            <v-card
                                class="pb-5"
                                style="overflow: hidden"
                            >
                                <v-row
                                    class="grey lighten-3"
                                >
                                    <v-card-title
                                        class="headline ml-3"
                                        primary-title
                                    >
                                        Add to List
                                    </v-card-title>
                                    <v-btn
                                        absolute
                                        small
                                        fab
                                        class="mr-3 text-right"
                                        style="top: 10px; right: 10px;"
                                        @click="cancelAddItem"
                                    >
                                        <v-icon>
                                            close
                                        </v-icon>
                                    </v-btn>
                                </v-row>
                                <v-row>
                                    <v-col
                                        class="px-10"
                                    >
                                        <v-row>
                                            <v-select
                                                v-model="newCategory"
                                                :items="categoryOptions"
                                                label="Category"
                                            ></v-select>
                                        </v-row>
                                        <v-row>
                                            <v-text-field
                                                v-model="newName"
                                                label="Name"
                                            ></v-text-field>
                                        </v-row>
                                        <v-row>
                                            <v-text-field
                                                v-model="newQuantity"
                                                label="Quantity"
                                                type="number"
                                            ></v-text-field>
                                        </v-row>
                                        <v-row>
                                            <v-select
                                                v-model="newUnits"
                                                :items="unitOptions"
                                                label="Units"
                                            ></v-select>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row
                                    class="mt-0 mx-5 pa-0"
                                >
                                    <v-col
                                        class="text-right ma-0 pa-0"
                                    >
                                        <v-btn
                                            color="red"
                                            class="mt-0 mr-4 white--text"
                                            @click.prevent="cancelAddItem"
                                        >
                                            Cancel
                                        </v-btn>

                                        <v-btn
                                            color="blue"
                                            class="mt-0 white--text"
                                            @click.prevent="saveItem"
                                            :disabled="!readyToSave"
                                        >
                                            Save
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-dialog>

                    </v-col>
                </v-row>
            </v-col>    <!-- end content width -->
        </v-row>
    </v-container>
</template>


<script>
let moment = require('moment');

export default {
    name: 'ShoppingList',
    data: () => ({
        moment: moment,
        addItem: false,
        newCategory: null,
        newName: null,
        newQuantity: null,
        newUnits: null,
    }),

    methods: {
        printWindow: function (){
            window.print();
        },
        checkBox: function(value) {
            this.$store.dispatch('menu/shoppingCheckBox',value);
        },
        saveItem: function(){
            //script needs to identify if the category exists or not, if so, use it, if not, add it. then get index of correct category, and add item.
            let a = this.$store.getters['menu/shoppingList'];
            let createCategory = true;
            let x;

            //check if the category already exists or if it needs to be created
            for (let i=0; i< a.length; i++) {
                if (a[i].category == this.newCategory) {
                    createCategory = false;
                }
            }

            //if the category needs to be created, create it
            if (createCategory) {
                this.$store.dispatch('menu/addCategory',this.newCategory);
            }
            
            //now that the category for sure exists, find the index of the category on the shoppingList object
            for (let j=0; j< a.length; j++) {
                if (a[j].category == this.newCategory) {
                    x = j;
                }
            }

            //now add the item to the items array within the identified index of the shoppingList
            let payload = {
            name: this.newName,
            quantity: this.newQuantity,
            units: this.newUnits,
            purchased: false,
            }
            this.$store.dispatch('menu/addItem',[x,payload])
            this.newCategory = null;
            this.newName = null;
            this.newQuantity = null;
            this.newUnits = null;
            this.addItem = false;
        },
        cancelAddItem: function() {
            this.addItem = false;
            this.newCategory = null;
            this.newName = null;
            this.newQuantity = null;
            this.newUnits = null;  
        }
    },

    computed: {
        weekStart() {
            return this.$store.getters['menu/weekStart'];
        },
        weekEnd() {
            return this.$store.getters['menu/weekEnd'];
        },
        weekOffset() {
            return this.$store.getters['menu/weekOffset'];
        },
        shoppingList(){
            return this.$store.getters['menu/shoppingList'];
        },
        showAllShoppingList: {
            get() {
                return this.$store.getters['menu/showAllShoppingList'];
            },
            set() {
                this.$store.dispatch('menu/showAllShoppingList')
            }
        },
        label() {
            if(this.showAllShoppingList == true) {
                return "All"
            } else {
                return "Un-Checked"
            }
        },
        unitOptions() {
            return this.$store.getters['menu/unitOptions'];
        },
        categoryOptions() {
            return this.$store.getters['menu/categoryOptions'];
        },
        readyToSave() {
            if(
                this.newCategory == null ||
                this.newName == null ||
                this.newQuantity == null ||
                this.newUnits == null
            ) {
                return false
            } else {
                return true
            }
        }
    }

};
</script>
